//src/pages/NovaEmpresa.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../axiosConfig";
import ComProtecao from "../components/ComProtecao";
import {
  ArrowLeft,
  Building2,
  CheckCircle2,
  MapPin,
  Save,
  Search,
  ShieldCheck,
} from "lucide-react";

import "./NovaEmpresa.css";

function NovaEmpresaConteudo() {
  const [form, setForm] = useState({
    cnpj: "",
    razao_social: "",
    cep: "",
    logradouro: "",
    numero: "",
    complemento: "",
    bairro: "",
    cidade: "",
    estado: "",
    ativa: 1,
  });

  const [salvando, setSalvando] = useState(false);
  const [consultandoCnpj, setConsultandoCnpj] = useState(false);
  const [consultandoCep, setConsultandoCep] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const consultarCNPJ = async () => {
    const cnpjLimpo = form.cnpj.replace(/\D/g, "");

    if (cnpjLimpo.length !== 14) return;

    try {
      setConsultandoCnpj(true);

      const res = await axios.get(`/consulta-cnpj/${cnpjLimpo}`);
      const data = res.data;

      if (!data?.erro) {
        setForm((prev) => ({
          ...prev,
          razao_social: data.nome || "",
          logradouro: data.logradouro || "",
          numero: data.numero || "",
          complemento: data.complemento || "",
          bairro: data.bairro || "",
          cidade: data.municipio || "",
          estado: data.uf || "",
          cep: data.cep?.replace(/\D/g, "") || "",
        }));
      } else {
        console.warn("CNPJ não encontrado.");
      }
    } catch (err) {
      console.error("Erro ao consultar CNPJ:", err);
    } finally {
      setConsultandoCnpj(false);
    }
  };

  const buscarCEP = async () => {
    const cepLimpo = form.cep.replace(/\D/g, "");

    if (cepLimpo.length !== 8) return;

    try {
      setConsultandoCep(true);

      const res = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
      const data = await res.json();

      if (!data.erro) {
        setForm((prev) => ({
          ...prev,
          logradouro: data.logradouro || "",
          bairro: data.bairro || "",
          cidade: data.localidade || "",
          estado: data.uf || "",
        }));
      }
    } catch (err) {
      console.error("Erro ao buscar CEP:", err);
    } finally {
      setConsultandoCep(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setSalvando(true);

      await axios.post("/empresas", form);

      alert("Empresa cadastrada com sucesso!");
      navigate("/empresas");
    } catch (err) {
      console.error("Erro ao cadastrar empresa:", err);
      alert("Erro ao cadastrar empresa.");
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div className="novaEmpresaAdmin-page">
      <div className="novaEmpresaAdmin-topbar">
        <div>
          <span className="novaEmpresaAdmin-kicker">Área administrativa</span>
          <h2>Nova empresa</h2>
          <p>
            Cadastre uma empresa participante do Tikpontos e mantenha os dados
            cadastrais e endereço atualizados.
          </p>
        </div>

        <button
          type="button"
          className="novaEmpresaAdmin-btn secondary"
          onClick={() => navigate("/empresas")}
        >
          <ArrowLeft size={16} />
          Voltar para empresas
        </button>
      </div>

      <form onSubmit={handleSubmit} className="novaEmpresaAdmin-card">
        <section className="novaEmpresaAdmin-section">
          <div className="novaEmpresaAdmin-sectionHeader">
            <div className="novaEmpresaAdmin-icon">
              <Building2 size={20} />
            </div>

            <div>
              <h3>Dados da empresa</h3>
              <span>Informe o CNPJ e os dados principais do cadastro.</span>
            </div>
          </div>

          <div className="novaEmpresaAdmin-grid">
            <div className="novaEmpresaAdmin-field span4">
              <label>CNPJ</label>

              <div className="novaEmpresaAdmin-inputAction">
                <input
                  name="cnpj"
                  value={form.cnpj}
                  onChange={handleChange}
                  onBlur={consultarCNPJ}
                  placeholder="00.000.000/0000-00"
                />

                <button
                  type="button"
                  onClick={consultarCNPJ}
                  disabled={consultandoCnpj}
                  title="Consultar CNPJ"
                >
                  <Search size={15} />
                </button>
              </div>

              <small>
                {consultandoCnpj
                  ? "Consultando CNPJ..."
                  : "Ao sair do campo, o sistema tenta preencher os dados automaticamente."}
              </small>
            </div>

            <div className="novaEmpresaAdmin-field span8">
              <label>Razão Social</label>
              <input
                name="razao_social"
                value={form.razao_social}
                onChange={handleChange}
                placeholder="Razão social da empresa"
              />
            </div>
          </div>
        </section>

        <section className="novaEmpresaAdmin-section">
          <div className="novaEmpresaAdmin-sectionHeader">
            <div className="novaEmpresaAdmin-icon teal">
              <MapPin size={20} />
            </div>

            <div>
              <h3>Endereço</h3>
              <span>Preencha o CEP para buscar automaticamente o endereço.</span>
            </div>
          </div>

          <div className="novaEmpresaAdmin-grid">
            <div className="novaEmpresaAdmin-field span3">
              <label>CEP</label>

              <div className="novaEmpresaAdmin-inputAction">
                <input
                  name="cep"
                  value={form.cep}
                  onChange={handleChange}
                  onBlur={buscarCEP}
                  placeholder="00000-000"
                />

                <button
                  type="button"
                  onClick={buscarCEP}
                  disabled={consultandoCep}
                  title="Buscar CEP"
                >
                  <Search size={15} />
                </button>
              </div>

              <small>{consultandoCep ? "Buscando CEP..." : "Consulta via CEP."}</small>
            </div>

            <div className="novaEmpresaAdmin-field span9">
              <label>Logradouro</label>
              <input
                name="logradouro"
                value={form.logradouro}
                onChange={handleChange}
                placeholder="Rua, avenida, praça..."
              />
            </div>

            <div className="novaEmpresaAdmin-field span3">
              <label>Número</label>
              <input
                name="numero"
                value={form.numero}
                onChange={handleChange}
                placeholder="Número"
              />
            </div>

            <div className="novaEmpresaAdmin-field span9">
              <label>Complemento</label>
              <input
                name="complemento"
                value={form.complemento}
                onChange={handleChange}
                placeholder="Sala, conjunto, bloco..."
              />
            </div>

            <div className="novaEmpresaAdmin-field span5">
              <label>Bairro</label>
              <input
                name="bairro"
                value={form.bairro}
                onChange={handleChange}
                placeholder="Bairro"
              />
            </div>

            <div className="novaEmpresaAdmin-field span5">
              <label>Cidade</label>
              <input
                name="cidade"
                value={form.cidade}
                onChange={handleChange}
                placeholder="Cidade"
              />
            </div>

            <div className="novaEmpresaAdmin-field span2">
              <label>UF</label>
              <input
                name="estado"
                value={form.estado}
                onChange={handleChange}
                maxLength={2}
                placeholder="UF"
              />
            </div>
          </div>
        </section>

        <section className="novaEmpresaAdmin-section">
          <div className="novaEmpresaAdmin-sectionHeader">
            <div className="novaEmpresaAdmin-icon orange">
              <ShieldCheck size={20} />
            </div>

            <div>
              <h3>Status</h3>
              <span>Defina se a empresa ficará ativa no sistema.</span>
            </div>
          </div>

          <div className="novaEmpresaAdmin-grid">
            <div className="novaEmpresaAdmin-field span4">
              <label>Status</label>
              <select
                name="ativa"
                value={form.ativa}
                onChange={(e) =>
                  setForm((prev) => ({
                    ...prev,
                    ativa: parseInt(e.target.value, 10),
                  }))
                }
              >
                <option value={1}>Ativa</option>
                <option value={0}>Inativa</option>
              </select>
            </div>
          </div>
        </section>

        <div className="novaEmpresaAdmin-actions">
          <button
            type="button"
            className="novaEmpresaAdmin-btn secondary"
            onClick={() => navigate("/empresas")}
          >
            <ArrowLeft size={16} />
            Cancelar
          </button>

          <button
            type="submit"
            className="novaEmpresaAdmin-btn primary"
            disabled={salvando}
          >
            {salvando ? (
              <>
                <CheckCircle2 size={16} />
                Salvando...
              </>
            ) : (
              <>
                <Save size={16} />
                Cadastrar empresa
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
}

export default function NovaEmpresa() {
  return (
    <ComProtecao rota="empresas" tipo="pode_inserir">
      <NovaEmpresaConteudo />
    </ComProtecao>
  );
}